var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-user"},[_c('page-title',{attrs:{"title":"NewUser Component"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }